import type { AuthUser } from "@playbrain/auth/dashboardRoles"
import { getUserRoleKeys } from "@playbrain/auth/dashboardRoles"

export const AUTH_EMAIL_MAX_LENGTH = 254

export function sanitizeEmailInput(value: unknown): string {
  if (typeof value !== "string") return ""
  return value.replaceAll("\u200B", "").trim().toLowerCase()
}

export function hasControlCharacters(value: string): boolean {
  for (const char of value) {
    const code = char.charCodeAt(0)
    if (code <= 31 || code === 127) return true
  }
  return false
}

export function hasDashboardAccess(user: AuthUser | null | undefined) {
  if (getUserRoleKeys(user).length > 0) return true
  return (
    Array.isArray(user?.permissions) && user.permissions.some((permission) => typeof permission === "string")
  )
}

export function errorMessage(error: unknown, fallback: string): string {
  const message = rawErrorMessage(error)
  if (!message) return fallback
  if (
    /\b(auth0|bucket|constraint|database|db|endpoint|er_[a-z0-9_]+|mysql|s3|sql|typeorm)\b/i.test(message)
  ) {
    return fallback
  }
  if (/^Verify your email address before signing in\./.test(message)) return message
  return /^Could not [a-z][\w\s-]+\.$/.test(message) ? message : fallback
}

export function isDashboardSessionAuthError(error: unknown): boolean {
  const message = rawErrorMessage(error).toLowerCase()
  return (
    message.includes("missing dashboard session") ||
    message.includes("dashboard access denied") ||
    message.includes("unauthenticated") ||
    message.includes("unauthorized")
  )
}

function rawErrorMessage(error: unknown) {
  return error instanceof Error ? error.message.trim() : ""
}
